import { useStore } from 'effector-react'
import { UseFormReturn } from 'react-hook-form'
import { uploadPhoto } from '~/features/DocumentBasedRegistration/helpers'
import {
  FixButtonWrapper,
  FormWrapper,
} from '~/features/DocumentBasedRegistration/styled'
import { Region } from '~/shared/api'
import { infoSourceOptions } from '~/shared/config/constants'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { phoneMaskOptions, snilsMaskOptions } from '~/shared/lib/maskito'
import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { Button } from '~/shared/ui/Buttons'
import {
  FormProvider,
  MaskInput,
  AsyncSelect,
  TextInput,
  PickPhotos,
  DaDataInput,
} from '~/shared/ui/form'
import { SelectMultiple } from '~/shared/ui/form/SelectMultiple'
import { FormValues } from './model'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
  disabledChangePhone?: boolean
}

export function Form({ onSuccess, form, disabledChangePhone }: FormProps) {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const { taxiparkIdQuery } = useTaxiparkQueryParams()

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <FormWrapper>
        <TextInput name='lastName' label='Фамилия' capitalize />
        <TextInput name='firstName' label='Имя' capitalize />
        <TextInput name='middleName' label='Отчество' capitalize />
        <MaskInput
          maskitoOptions={phoneMaskOptions}
          name='phone'
          label='Телефон'
          disabled={disabledChangePhone}
        />
        <TextInput name='email' label='Email' />
        <AsyncSelect
          name='regionCode'
          label='Регион работы'
          modalTitle='Регион работы'
          fetchOptions={() => Region.fetchOptions(taxiparkIdQuery)}
        />
        {featureFlags.address_suggestions_dadata ? (
          <DaDataInput
            name='placeOfResidence'
            label='Фактический адрес проживания'
          />
        ) : (
          <TextInput
            name='placeOfResidence'
            label='Фактический адрес проживания'
          />
        )}

        <MaskInput
          maskitoOptions={snilsMaskOptions}
          name='snils'
          label='СНИЛС'
        />
        {featureFlags.address_suggestions_dadata ? (
          <DaDataInput name='birthPlace' label='Место рождения' />
        ) : (
          <TextInput name='birthPlace' label='Место рождения' />
        )}

        <SelectMultiple
          field='infoSource'
          label='Откуда вы о нас узнали'
          modalTitle='Откуда вы о нас узнали'
          options={infoSourceOptions}
          name='infoSource'
        />

        <PickPhotos
          descriptions='Добавьте свою фотографию, для персональной идентификации при выдаче автомобиля'
          name='photo'
          fnUpload={(file: Blob) => uploadPhoto(file, taxiparkIdQuery)}
          maxPhotos={1}
        />
        <FixButtonWrapper>
          <Button
            variant='limeFlooded'
            size='large'
            type='submit'
            fullWidth
            data-test-id='basic-step-button'
          >
            Продолжить
          </Button>
        </FixButtonWrapper>
      </FormWrapper>
    </FormProvider>
  )
}
